const BANNER_API = '/sitecore/api/ssc/isagenix/PromotionBannerModalApi/1';
const INVENTORY_API = '/sitecore/api/ssc/isagenix/inventoryapi/1';

export async function getPromotionBannerModal(referenceId) {
    var url = `${BANNER_API}/PromotionBannerModal?ReferenceId=${referenceId}`;
    return $.ajax({
        type: 'GET',
        url: url
    });
}

export async function checkInventory(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${INVENTORY_API}/getinventory`,
        contentType: 'application/json',
        dataType: 'json',
        data: {
            ids: request.join(',')
        }
    });
}

export async function checkStock(request) {
    let unavailable = [];
    try {
        let response = await checkInventory(request);
        if(!Array.isArray(response)) return unavailable;

        unavailable = response.filter(i => i.Count < 1).map(i => i.ItemId);

        request.forEach(function (item) {
            if(!response.some(function (r) { return r.ItemId === item; })) {
                if(!unavailable.includes(item)) {
                    unavailable.push(item);
                }
            }
        });
    } catch (ex) {
        console.error(ex);
    }
    return unavailable;
}
